import styled, { css } from 'styled-components';
import { TradeViewVariant } from '../../types/trade';
import isOmpPlatform from '../../utils/isOmpPlatform';

const isOmp = isOmpPlatform();
/**
 * Variant Definitions
 */
const StyledTimerVariants = {
  warn: css`
    color: ${({ theme }) => theme.COLORS.MONZA};
    font-family: ${({ theme }) => theme.FONT.REGULAR};
  `,
  alert: css`
    color: ${({ theme }) => theme.COLORS.MONZA};
    font-family: ${({ theme }) => theme.FONT.SEMI_BOLD};
  `,
  bold: css`
    font-family: ${({ theme }) => theme.FONT.SEMI_BOLD};
  `
};

const StyledTimerLocations = {
  [TradeViewVariant.LIST]: css`
    display: flex;
    padding: ${({ isTimerExtended }) => isTimerExtended && '4px 8px'};
  `,

  [TradeViewVariant.VDP]: css`
    font-size: ${({ theme }) => theme.FONT_SIZES.SMALL};
    box-shadow: ${isOmp ? '' : '0px 1px 6px rgba(0, 0, 0, 0.2)'};
    padding: 4px 8px;
  `
};

const StyledExtendedTimer = css`
  white-space: nowrap;
`;

const StyledTimer = styled.div`
  color: ${({ theme }) => theme.COLORS.BASE_INVERTED};
  font-size: ${({ theme }) => theme.FONT_SIZES.SMALL};
  font-family: ${({ theme }) => theme.FONT.REGULAR};
  line-height: ${({ theme }) => theme.FONT_SIZES.SMALL};
  border-radius: ${({ showExtendedIndicator }) =>
    showExtendedIndicator ? '3px 0 0 3px' : '3px'};
  background: ${({ theme }) => theme.COLORS.BASE};
  z-index: 1;
  align-self: flex-end;
  width: max-content;
  ${({ showExtendedIndicator }) => showExtendedIndicator && StyledExtendedTimer}
  ${({ variant }) => StyledTimerVariants[variant]}
  ${({ location }) => StyledTimerLocations[location]}
`;

export default StyledTimer;
